// Second Thought motion layer (2026-10-22). Small, physical effects that run once or follow the
// pointer, never loop: products settle onto the surface as they scroll in, tilt toward the cursor
// with a counter-moving shadow, buttons lean
// toward the pointer, and the clicked cutout morphs into the product photo (view transitions).
// Pointer effects only with a fine pointer; everything off under prefers-reduced-motion.
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fine = matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (reduce) return;

  // 1. settle: each product drops onto the surface once, in reading order
  const settle = () => {
    const items = document.querySelectorAll(
      ".st-field__item:not([data-st-in])",
    );
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          const col = [...el.parentElement.children].indexOf(el) % 4;
          el.style.setProperty("--st-delay", `${col * 70}ms`);
          el.dataset.stIn = "1";
          io.unobserve(el);
        });
      },
      { rootMargin: "0px 0px -8% 0px" },
    );
    items.forEach((el) => {
      el.dataset.stWait = "1";
      io.observe(el);
    });
  };

  // 2. tilt + counter shadow (the "view" cursor badge was removed 2026-10-22: he found it annoying)
  const tilt = () => {
    let raf = 0;
    document.querySelectorAll(".st-field__link").forEach((link) => {
      const img = link.querySelector(".st-field__obj img");
      link.addEventListener("pointermove", (ev) => {
        const r = link.getBoundingClientRect();
        const x = (ev.clientX - r.left) / r.width - 0.5;
        const y = (ev.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          img.style.transform = `perspective(700px) rotateY(${x * 14}deg) rotateX(${-y * 10}deg) translateY(-6px) scale(1.03)`;
          img.style.filter = `drop-shadow(${-x * 22}px ${20 - y * 8}px 20px rgba(0,0,0,.18))`;
        });
      });
      link.addEventListener("pointerenter", () => {
        link.classList.add("is-hover");
      });
      link.addEventListener("pointerleave", () => {
        cancelAnimationFrame(raf);
        img.style.transform = "";
        img.style.filter = "";
        link.classList.remove("is-hover");
      });
    });
  };

  // 4. magnetic buttons: lean a few pixels toward the pointer
  const magnet = () => {
    document
      .querySelectorAll(
        '.st-shop__link, .st-shop__cta, .product-details button[name="add"], footer .email-signup__button',
      )
      .forEach((b) => {
        b.addEventListener("pointermove", (ev) => {
          const r = b.getBoundingClientRect();
          const dx = (ev.clientX - (r.left + r.width / 2)) / r.width;
          const dy = (ev.clientY - (r.top + r.height / 2)) / r.height;
          b.style.translate = `${dx * 8}px ${dy * 6}px`;
        });
        b.addEventListener("pointerleave", () => {
          b.style.translate = "";
        });
      });
  };

  // 5. the clicked cutout carries the morph into the product page
  const morph = () => {
    document.querySelectorAll(".st-field__link").forEach((link) => {
      link.addEventListener("click", () => {
        const img = link.querySelector(".st-field__obj img");
        if (img) img.style.viewTransitionName = "st-product";
      });
    });
    addEventListener("pageshow", () => {
      document.querySelectorAll(".st-field__obj img").forEach((i) => {
        i.style.viewTransitionName = "";
      });
    });
  };

  const init = () => {
    settle();
    morph();
    if (fine) {
      tilt();
      magnet();
    }
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
